module.exports = __webpack_public_path__ + "static/media/Linnunlaulu2_ja_tuuli2.6a81d70d.mp3";